module.exports = __webpack_public_path__ + "assets/img/Home.5f621113-ps.jpg";